module.exports = __webpack_public_path__ + "img/fruit-pineapple-350x184.8a3f54ef.jpg";